import axios from 'axios'
import { CONFIGS } from '../configs'

export default {  

  get_shipping_waiting(status) {
    //if(page === undefined) page = 1
    //if(search === undefined || search==='') search = ''; else search = '&search='+search
    var page=1;

    if(status === undefined || status==='') status = ''; else status = '&status='+status
    return axios.get(CONFIGS.API_SERVER + '/signature/?ordering=-id&page='+page+status)
  },

  
  get_signature_expiring(start, end){
    //return 13
    return axios.post(CONFIGS.API_SERVER + '/api/reports/expired_signatures', {'start': start, 'end': end})
  },

  get_month_count(start, end, status){
    return axios.post(CONFIGS.API_SERVER + '/api/reports/month_count', {'start': start, 'end': end, 'status': status})
    //return axios.post(CONFIGS.API_SERVER + '/api/get_shipping_price/', data)
  },


}
